import React from 'react'
import PropTypes from 'prop-types'

const ProgramTagDivider = () => <div className={'program-tag-divider'}></div>

const ProgramTag = ({
  type = '',
  text = '',
  prependDivider = false,
  className = '',
  onClick = null,
  content = '',
}) => {
  let spanClass = type ? 'program-tag heading-5 program-tag-' + type : 'program-tag'
  if (type !== 'address') {
    spanClass += ' heading-5'
  }
  spanClass += ` ${className}`
  if (onClick) {
    spanClass += ' show-cursor-pointer'
  }
  let tagSpan
  if (type === 'website') {
    tagSpan = <a href={content} className={spanClass} target={'_blank'} rel={'noopener noreferrer'}>{text}</a>
  } else if (type === 'phone'){
    tagSpan = <a href={`tel:${text}`} className={spanClass} target={'_blank'} rel={'noopener noreferrer'}>{text}</a>
  } else if (type === 'email') {
    tagSpan = <a href={`mailto:${content}`} className={spanClass}>{text}</a>
  } else {
    tagSpan = <span className={spanClass} onClick={onClick}>{text}</span>
  }
  return (prependDivider)
    ? <><ProgramTagDivider/>{tagSpan}</>
    : tagSpan
}
ProgramTag.propTypes = {
  type           : PropTypes.string,
  text           : PropTypes.string,
  prependDivider : PropTypes.bool,
  className      : PropTypes.string,
  onClick        : PropTypes.func,
  content        : PropTypes.string,
}

export default React.memo(ProgramTag)